// BM-H3969 (solicitor's rulings of 8 Oct 2026): the two lifetime-transfer questions. The wording and help text below are the
// solicitor's APPROVED text, character for character; a test pins them. Answers are real booleans saved at
// s1_testator.lifetime_transfers and are NEVER defaulted: until the client chooses, the field is absent, which reads as
// "not asked" (never "no"), so a questionnaire saved before these questions existed stays "not asked".
//
// Option B (solicitor, second ruling): asked of EVERY client, whatever structure they choose, and shown to the fee earner on
// every matter (WillConfirmationsPanel). They are general information about the client's own history, so they sit in
// "About you" (S1Testator) beside the other facts about the client that matter to tax (overseas assets, earlier wills), and
// nothing here depends on the nil-rate band trust. A yes does not stop the client submitting. The Will wording does not change.
// Clause C-14c's separate requirement (the fee earner's "Available nil-rate band reviewed", backend wills_confirmations.py)
// reads these answers but is a different thing from asking and recording them.

import { QuestionRow, YesNo } from "./fields";

export const LIFETIME_BLOCK = "lifetime_transfers";
export const TRUST_TRANSFERS_FIELD = "trust_transfers_last_14_years";
export const OTHER_GIFTS_FIELD = "other_gifts_last_7_years";

export const TRUST_TRANSFERS_QUESTION = "In the last 14 years, have you transferred money or property into a trust during your lifetime, or added money or property to an existing trust?";
export const TRUST_TRANSFERS_HELP = "Do not include a trust created by your Will. Include transfers into settlements or trusts even if you or your family could benefit.";
export const OTHER_GIFTS_QUESTION = "In the last 7 years, have you given away money or property, sold anything for less than its full value, or otherwise transferred value to another person?";
export const OTHER_GIFTS_HELP = "Include substantial gifts to family or friends. Do not try to decide whether a gift was exempt. Your fee earner will check that.";

// A real true or false, or null when the client has not answered. Anything else counts as not answered.
export function lifetimeAnswer(section, field) {
  const v = section?.[LIFETIME_BLOCK]?.[field];
  return typeof v === "boolean" ? v : null;
}

export default function LifetimeTransfers({ s, set }) {
  const lt = s[LIFETIME_BLOCK] || {};
  const edit = (field, v) => set({ [LIFETIME_BLOCK]: { ...lt, [field]: v } });
  return (
    <div data-testid="s1-lifetime-transfers">
      <QuestionRow qid="s1_testator.lifetime_transfers.trust_transfers_last_14_years" label={TRUST_TRANSFERS_QUESTION} hint={TRUST_TRANSFERS_HELP}>
        <YesNo testid="s1-lifetime-trust-transfers" value={lifetimeAnswer(s, TRUST_TRANSFERS_FIELD)} onChange={(v) => edit(TRUST_TRANSFERS_FIELD, v)} />
      </QuestionRow>
      <QuestionRow qid="s1_testator.lifetime_transfers.other_gifts_last_7_years" label={OTHER_GIFTS_QUESTION} hint={OTHER_GIFTS_HELP}>
        <YesNo testid="s1-lifetime-other-gifts" value={lifetimeAnswer(s, OTHER_GIFTS_FIELD)} onChange={(v) => edit(OTHER_GIFTS_FIELD, v)} />
      </QuestionRow>
    </div>
  );
}
